<template>
  <div>
    <div class="form-check form-switch">
      <input
        type="checkbox"
        class="form-check-input"
        @click="toggle"
        :checked="published"
      />
      <label class="form-check-label" @click="toggle"></label>
    </div>
  </div>
</template>

<script>
export default {
  props: ['course', 'article'],
  data() {
    if (this.course) {
      return {
        published: this.course.is_published,
        working: false,
      }
    }
    if (this.article) {
      return {
        published: this.article.is_published,
        working: false,
      }
    }
  },
  computed: {
    message() {
      if (this.published) {
        return this.$t('Published')
      }
      return this.$t('Draft')
    },
  },
  methods: {
    publish() {
      if (this.article) {
        return this.$api.articlePublish(this.article.id)
      }
      if (this.course) {
        return this.$api.coursePublish(this.course.id)
      }
    },
    toggle() {
      if (this.working) {
        return false
      }
      this.working = true

      this.publish()
        .then((response) => {
          this.$set(this.course, 'is_published', response.data.is_published)
          this.published = response.data.is_published
          iziToast.success({
            title: 'OK',
            message: this.message,
            position: 'bottomLeft',
          })
          this.working = false
        })
        .catch((e) => {
          if (e.response && e.response.status === 419) {
            iziToast.success({
              title: this.$t('Warning'),
              message: this.$t('Your session has expired - please reload'),
              position: 'bottomLeft',
            })
          }
        })
    },
  },
}
</script>
